<div class="w-full container" *transloco="let t; prefix: 'contact'">
  <div class="container flex py-7">
    <h1 class="h1 text-black">{{t('title')}}</h1>
  </div>
  <div
    class="flex flex-col md:flex-row container justify-between border border-gray-200 bg-gray-50 rounded-lg p-8 md:gap-14 gap-8 ">
    <div
      class="flex flex-col justify-between border-b md:border-r md:border-b-0 border-gray-200 flex-1 gap-3 pb-6 md:pb-0">
      <span class="text-xl text-black">{{t('where-to-find')}}</span>
      <a class="text-base text-primary-700 underline" href="https://maps.app.goo.gl/mipSgx39dR13maoC6"
        target="_blank">Ελευθερίου Βενιζέλου 132, Καλλιθέα</a>
    </div>
    <div
      class="flex flex-col justify-between border-b md:border-r md:border-b-0 border-gray-200 flex-1 gap-3 pb-6 md:pb-0">
      <span class="text-xl text-black">{{t('send-us-email')}}</span>
      <a class="text-base text-primary-700 underline" href="mailto:hello@uniko.gr" target="_top">hello&#64;uniko.gr</a>
    </div>
    <div class="flex flex-col justify-between flex-1 gap-3">
      <span class="text-xl text-black">{{t('call-us')}}</span>
      <span class="text-base text-gray-900">Αθήνα: +30 2102040000</span>
    </div>
  </div>
  <section class="container pt-8 pb-12 px-0">
    <div class="mx-auto border rounded-lg bg-white p-4 md:p-8">
      <h1 class="h1 text-black mb-6">{{t('form-title')}}</h1>
      <h2 class="mb-8 text-gray-900">{{t('form-description')}}</h2>
      <form class="flex flex-col gap-4 md:gap-8" [formGroup]="form">
        <div class="flex md:flex-row flex-col gap-4 md:gap-14">
          <fieldset class="flex flex-col gap-2 group/input flex-1">
            <label
              class="font-semibold flex items-center text-gray-950 group-disabled:text-gray-300 gap-4"><span>{{t('name')}}
                <span class="text-error">*</span></span></label>
            <input [placeholder]="t('name-placeholder')" formControlName="fullName" mask="A* S*"
              class="bg-white text-gray-500 rounded-full border border-gray-300 py-3 px-4 group-focus-within/input:border-[1.5px] group-focus-within/input:text-gray-900 group-focus-within/input:border-primary-500 transition-colors duration-300 outline-none">
          </fieldset>
          <fieldset class="flex flex-col gap-2 group/input flex-1">
            <label
              class="font-semibold flex items-center text-gray-950 group-disabled:text-gray-300 gap-4"><span>{{t('email')}}
                <span class="text-error">*</span></span></label>
            <input [placeholder]="t('email-placeholder')" formControlName="email"
              class="bg-white text-gray-500 rounded-full border border-gray-300 py-3 px-4 group-focus-within/input:border-[1.5px] group-focus-within/input:text-gray-900 group-focus-within/input:border-primary-500 transition-colors duration-300 outline-none">
          </fieldset>
        </div>
        <fieldset class="flex flex-col gap-2 group/input">
          <label
            class="font-semibold flex items-center gap-4 text-gray-950 group-disabled:text-gray-300"><span>{{t('message-question')}}
              <span class="text-error">*</span></span></label>
          <textarea rows="5" formControlName="message"
            class="bg-white text-gray-500 rounded-[1.5rem] border border-gray-300 py-3 px-4 group-focus-within/input:border-[1.5px] group-focus-within/input:text-gray-900 group-focus-within/input:border-primary-500 transition-colors duration-300 outline-none"
            [placeholder]="t('message-placeholder')"></textarea>
        </fieldset>
        <div class="flex flex-col md:flex-row justify-between gap-5 md:gap-0">
          <div class="flex flex-col gap-3 max-w-[460px]">
            <div class="flex-1 border border-gray-300 rounded-lg p-4 w-full">
              <label role="button" for="menu-item-checkmark-1" class="menu-item-checkmark border-0 hover:!bg-white">
                <input type="checkbox" class="hidden" id="menu-item-checkmark-1" name="menu-item-checkmark"
                  formControlName="acceptTerms" />
                <div>
                  <span class="font-semibold text-sm">{{t('agree-with')}}
                    <a [localizedRouterLink]="['/terms-and-conditions']"
                      [queryParams]="{ documentType: 'terms-and-conditions' }" target="_blank" class="text-primary-500">
                      {{t('terms-conditions')}}</a>
                  </span>
                </div>
              </label>
            </div>
            <re-captcha #recaptcha="reCaptcha" [siteKey]="siteKey" formControlName="recaptcha"
              size="invisible"></re-captcha>
            <div class="flex-1 border border-gray-300 rounded-lg p-4 w-full justify-between flex flex-row items-center">
              <div class="w-3/6">
                <label role="button" for="menu-item-checkmark-2"
                  class="menu-item-checkmark border-0 hover:!bg-white p-0">
                  <input type="checkbox" class="hidden" id="menu-item-checkmark-2" name="menu-item-checkmark"
                    (click)="onCaptchaClick()"
                    [checked]="form.get('recaptcha')?.value != null && form.get('recaptcha')?.value != ''" />
                  <div>
                    <span class="font-semibold text-sm">{{'shared.labels.notARobot' | transloco}}</span>
                  </div>
                </label>
              </div>
              <div class="w-[44.8px] h-[44px]">
                <img class="bg-white p-2 rounded-[4px]" src="../../../assets/img/recaptcha-logo.png" />
              </div>
            </div>
          </div>
          <div class="content-end">
            <button [disabled]="!(isFormValid)" (click)="submitForm()"
              class="btn-primary flex-1c flex-nowrap min-w-[205px]">
              @if (loading) {
              <app-loader [withBackground]="false" variant="primary" [width]="25"></app-loader>
              } @else {
              {{t('buttons.send-message')}}
              }
            </button>
          </div>
        </div>
      </form>
    </div>
  </section>
</div>